// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

// import third-party libraries
import classNames from 'classnames';
import { DateTime } from 'luxon';

import AlertModal from '../../../global/components/modals/AlertModal.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";

// import moduleCertificate css modules
import moduleCertificateStyles from '../moduleCertificateModuleStyles.css';

const simUrl = window.simUrl;
// not updating links here because this should no longer be used with london handling agenda and certs

class ModuleCertificateListItem extends Base {
  constructor(props) {
    super(props);
    this.state = {
      trailerModalOpen: false 
    }
    this._bind(
      '_handleStartOver'
    )
  }

  _handleStartOver(contentModule) {
    // TODO: athens 2.0 investigate
    const { dispatch, history } = this.props;
    dispatch(userModuleActions.sendCreateUserModule({
      _contentModule: contentModule._id
    })).then(json => {
      if(json.success) {
        // TODO: CHECK IF WE TO INVALIDATE THE LIST OR ANYTHING HERE
        // created new one, now send them to it
        history.push(`/my-agenda/cms/${contentModule.slug}`)
      } else {
        alert(`ERROR: ${json.error}`);
      }
    })
  }

  render() {
    const { moduleCertificate, contentModule } = this.props; 
    return (
      <div className="yt-col s_50 m_33 l_20">
        <Link to={`/my-certificates/${moduleCertificate._id}`}>
          <div className={`cert-card -${moduleCertificate.status}`}>
            <img src="/img/cert-item.jpg"/>
            <div className="-title">
              {contentModule ? contentModule.title : ""}
            </div>
            {
              moduleCertificate.expires ?
                <div className="-expires">
                  Valid through {DateTime.fromISO(moduleCertificate.expires).toLocaleString(DateTime.DATE_MED)}
                </div>
              : null
            }
            {
              moduleCertificate.status !== 'completed' ?
                <div style={{marginTop: '10px'}} className="-button -expired">{moduleCertificate.status.toUpperCase()}</div>
              : null
            }
          </div>
        </Link>
        {/* <AlertModal
          alertMessage="Are you sure you want to restart your training?"
          alertTitle={"Confirm Restart Training"}
          closeAction={() => this.setState({confirmStartOver: false})}
          confirmAction={this._handleStartOver}
          confirmText={"Yes, continue"}
          declineAction={() => this.setState({confirmStartOver: false})}
          declineText={"Cancel"}
          isOpen={confirmStartOver}
          type="danger"
        /> */}
      </div>
    )
  }
}

ModuleCertificateListItem.propTypes = {
  moduleCertificate: PropTypes.object.isRequired
  , contentModule: PropTypes.object.isRequired
}

export default withRouter(ModuleCertificateListItem);



// WEBPACK FOOTER //
// modules/moduleCertificate/components/ModuleCertificateListItem.js.jsx